import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,.4);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: flex-end;

    .sub-page {
        display: none;
        
        &:last-child {
            display: flex;
        }
    }

`;